const initialState = {};

function reducer(state = initialState, action) {
    if (
        action.type === 'AUTHENTICATE_REQUEST' ||
        action.type === 'LOGOUT_REQUEST' ||
        action.type === 'IMPORT_SPARE_PART_ARTICLES_RESET'
    ) {
        return initialState;
    }

    if (
        action.type === 'IMPORT_SPARE_PART_ARTICLES_REQUEST' ||
        action.type === 'IMPORT_SPARE_PART_ARTICLES_START'
    ) {
        return { loading: true };
    }

    if (
        action.type === 'IMPORT_SPARE_PART_ARTICLES_FAILURE' ||
        action.type === 'IMPORT_SPARE_PART_ARTICLES_SUCCESS'
    ) {
        return action.payload;
    }

    return state;
}

export default reducer;
